<template lang="pug">
div
  v-sheet.text-sm.clickable.border-menu.mt-2(flat outlined :min-width="minWidth" @click="openSelectDateDialog = true")
    .d-flex.align-center.justify-space-between.px-4(:style="height ? `height: ${height}px;` : 'height: 36px;'")
      .text-sm.neutral700--text(v-if="value") {{ value | convertToDateOnly }}
      .text-sm.neutral500--text(v-else) {{ placeholder }}
      div
        v-btn.mr-2(v-if="value && clearable" icon @click.stop="$emit('input', null)")
          v-icon(size="18") mdi-close
        v-icon(size="20") $yzi-calendar
        .dialogs
    medical-document-select-date-dialog(v-if="openSelectDateDialog" :open.sync="openSelectDateDialog" :parentDateDetails="dateDetails" @confirmed="onConfirmSelectedDate")
</template>

<script>
import { DateTime } from 'luxon'
import MedicalDocumentSelectDateDialog from '@/components/clinic/dialogs/MedicalDocumentSelectDateDialog.vue'

export default {
  components: {
    MedicalDocumentSelectDateDialog,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select date'
    },
    minWidth: {
      type: String,
      default: '240'
    },
    title: {
      type: String,
      default: 'Select date'
    },
    clearable: {
      type: Boolean
    },
    height: {
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
      openSelectDateDialog: false,
    }
  },
  computed: {
    todayDate () {
      return DateTime.local().toISODate()
    },
    dateDetails () {
      return {
        date: this.value,
        title: this.title,
      }
    },
  },
  methods: {
    onConfirmSelectedDate (date) {
      this.$emit('input', date)
    },
  },
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--yz-neutral-400);
  border-radius: 10px;
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--yz-danger);
  border-radius: 10px;
  box-shadow: none;
}
</style>